<template>
	<div class="wrapper">
		<vxe-toolbar>
			<template v-slot:buttons>
				<vxe-button status="my-orange" @click="showSearch(false)" v-if="seachStatus">隐藏查询</vxe-button>
				<vxe-button status="my-orange" icon="fa fa-search" @click="showSearch(true)" v-if="!seachStatus">查询</vxe-button>
			</template>
		</vxe-toolbar>
		<div class="search" v-if="seachStatus">
			<vxe-form title-align="right" title-width="120" title-colon :data="searchData" @submit="searchEvent" @reset="searchReset">
				<vxe-form-item title="姓名" span="8">
					<vxe-input v-model="searchData.userName" placeholder="请输入菜单名称" clearable></vxe-input>
				</vxe-form-item>
				<vxe-form-item title="开始时间" span="8">

					<el-date-picker
            			style="width:100%;"
            			v-model="searchData.beginTime"
            			type="datetime"
						format="yyyy-MM-dd HH:mm:ss"
            			value-format="yyyy-MM-dd HH:mm:ss"
            			placeholder="选择日期">
          			</el-date-picker>
				</vxe-form-item>
				<vxe-form-item title="结束时间" span="8">
					<el-date-picker
            			style="width:100%;"
            			v-model="searchData.endTime"
            			type="datetime"
						format="yyyy-MM-dd HH:mm:ss"
            			value-format="yyyy-MM-dd HH:mm:ss"
            			placeholder="选择日期">
          			</el-date-picker>
				</vxe-form-item>
				<vxe-form-item align="center" span="24">
					<vxe-button type="submit" status="my-orange" icon="fa fa-check">应用</vxe-button>
					<vxe-button type="reset" status="my-orange" icon="fa fa-undo">重置</vxe-button>
				</vxe-form-item>
			</vxe-form>
		</div>
		<div class="table">
			<vxe-grid border stripe resizable auto-resize :columns="tableColumn" :data="tableData" :loading="loading">
				<template v-slot:operation="{ row }">
					<vxe-button type="text" status="primary" @click="goPage('detail', row)">详情</vxe-button>
				</template>
			</vxe-grid>
		</div>
		<!-- 分页 -->
		<div class="page">
			<vxe-pager :current-page.sync="tablePage.currentPage" :page-size.sync="tablePage.pageSize" :page-sizes="tablePage.pageSizes"
			 :total="tablePage.totalResult" :layouts="layouts" @page-change="pageChange"></vxe-pager>
		</div>
	</div>
</template>

<script>
	import {
		mapState,
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		data() {
			return {
				loading: false,
				seachStatus: false,
				 serveRoleList: [],
				searchData: {},
				// 分页的参数配置
				tablePage: {
					totalResult: 0,
					currentPage: 1,
					pageSize: 10,
					align: "left",
					pageSizes: [10, 20, 50, 100, 500, 1000],
					perfect: true
				},
				tableColumn: [{
						type: 'seq',
						title: '序号',
						width: 50,
						align: "center"
					},
					{
						field: 'reqUrl',
						title: '访问路径',
						showOverflow: true,
						align: "center",
						minWidth: "200"
					},
					{
						field: 'reqBeginTime',
						title: '开始时间',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'reqEndTime',
						title: '结束时间',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'userName',
						title: '请求用户',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'reqCostTime',
						title: '处理时长（秒）',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'reqParam',
						title: '请求参数',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						field: 'respData',
						title: '处理结果',
						showOverflow: true,
						align: "center",
						minWidth: "120"
					},
					{
						title: '操作',
						width: 120,
						showOverflow: true,
						slots: {
							default: 'operation'
						},
					}
				],
				tableData: [],
			}
		},
		computed: {
			...mapState([
				"layouts"
			]),
		},
		created() {
			this.initView()
		},
		methods: {
			...mapActions([
				"getLogListServe"
			]),
			initView() {
				this.getLists();
			},
			// 是否显示查询功能
			showSearch(bool) {
				this.seachStatus = bool;
			},
			goPage(type, itemData) {
				if (type == 'viewLine') {	
				} else {
				}
			},
			getLists() {
				this.loading = true;
				this.getLogListServe({
					current: this.tablePage.currentPage,
					size: this.tablePage.pageSize,
					param: {
						userName: this.searchData.userName,
						beginTime: this.searchData.beginTime,
						endTime: this.searchData.endTime,
					}
				}).then(res => {
					if (res.code == 200) {
						this.tableData = res.data.records;
						this.tablePage.totalResult = +res.data.total;
					}
					this.loading = false;
				})
			},
			// 分页功能
			pageChange(item) {
				if (item.type == "size") {
					this.tablePage.currentPage = 1;
				} else {
					this.tablePage.currentPage = item.currentPage;
				}
				this.getLists();
			},
			searchEvent() {
				console.log(this.searchData);
				this.seachStatus = false;
				this.getLists();
			},
			searchReset() {
				this.searchData = {};
				this.getLists();
			},
		}
	}
</script>

<style lang="scss" scoped>
	.wrapper{
	  .datetime{
	    display: flex;
	    align-items: center;
	    span{
	      margin: 0 3px;
	    }
	  }
	}
	.sign i {
		margin-right: 3px;
		display: inline-block;
		width: 10px;
		height: 10px;
		border-radius: 50%;
	}
</style>
